function createLabelValueOption(input) {
    if (!input) return input;
    return {
        label: input,
        value: input,
    };
}

export default createLabelValueOption;
